module.exports = __webpack_public_path__ + "img/logo.f3103225.svg";